import apiurl from './apiurl';
import axios from 'axios';

const checkDocumentosCargados = async (idToken, fecha) => {
    console.log('checkDocumentosCargados: ' + JSON.stringify(fecha));

    try {
        const response = await axios({
            'method': 'GET',
            'url': apiurl + 'checkDocumentosCargados',
            'headers': {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + idToken
            },
            'params': {
                fecha
            }
        })
        return response;
    } catch (error) {
        throw error;
    }

};

export default checkDocumentosCargados;
